import classNames from 'classnames/bind';
import styles from './PostDetailMobile.module.scss';
import ConfirmModal from '~/component/ConfirmModal';
import { BASE_URL_IMG, postData } from '~/helper/apiService';
import { useContext, useEffect, useRef, useState } from 'react';
import { LoginContext } from '~/component/Context/LoginProvider';
import { ToastContext } from '~/component/Context/ToastProvider';
import { FetchDataContext } from '~/component/Context/FetchDataProvider';
import { ModalOverLayContext } from '~/component/Context/ModalOverLayProvider';
import EditPost from '~/component/EditPost';
import useWindowWidth from '~/hooks/useWindowWidth';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendar, faComment, faHeart, faPaperPlane } from '@fortawesome/free-regular-svg-icons';

const cx = classNames.bind(styles);

function PostDetailMobile({ post, comments, formRef, listRef, handleLike, onAddComment }) {
  const { setModalComponentContent } = useContext(ModalOverLayContext);
  const { loadPosts } = useContext(FetchDataContext);
  const { addToast } = useContext(ToastContext);
  const { loginStatus } = useContext(LoginContext);
  const [like, setLike] = useState(0);
  const [isHovered, setIsHovered] = useState(false);
  const [imageLoaded, setImageLoaded] = useState(false);

  const commentRef = useRef();
  const windowWidth = useWindowWidth();

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      onAddComment(e);
    }
  };

  const handleEdit = (e) => {
    e.preventDefault();
    setModalComponentContent(<EditPost id={post.id} />);
  };

  const handleConfirmDelete = async () => {
    const formData = new FormData();
    formData.append('id', post.id);
    const res = await postData('/post/delete', formData);
    if (res.status === 'success') {
      loadPosts();
      setModalComponentContent(null);
    } else {
      addToast(res);
    }
  };

  const handleCancelDelete = () => {
    setModalComponentContent(null);
  };

  const handleDelete = (e) => {
    e.preventDefault();
    setModalComponentContent(
      <ConfirmModal
        title="Xác nhận xóa bài viết"
        handleConfirm={handleConfirmDelete}
        handleCancel={handleCancelDelete}
      />,
    );
  };

  if (!handleLike) {
    handleLike = async () => {
      const formData = new FormData();
      formData.append('id', post.id);
      const res = await postData('/post/like', formData);
      if (res.status === 'success') {
        setLike((prev) => prev + 1);
      } else {
        addToast(res);
      }
    };
  }

  useEffect(() => {
    setLike(post.likes);
  }, [post]);

  return (
    <div className={cx('wrapper')}>
      <div className={cx('scroll')}>
        {post.img && (
          <div className={cx('post-image-wrapper')}>
            {!imageLoaded && <div className={cx('image-skeleton')} />}
            <img
              src={BASE_URL_IMG + '/' + post.img}
              alt="Post"
              className={cx('post-image', { loaded: imageLoaded })}
              loading="lazy"
              onLoad={() => setImageLoaded(true)}
            />
          </div>
        )}

        <div className={cx('post-details')}>
          <div className={cx('post-nav')}>
            <h2 className={cx('post-title')}>{post.title}</h2>
            <p className={cx('post-content')}>{post.content}</p>
          </div>

          <div className={cx('post-meta')}>
            <div className={cx('post-meta-box')}>
              <button className={cx('interaction-btn')} onClick={handleLike}>
                <FontAwesomeIcon className={cx('icon')} icon={faHeart} />
                <span className={cx('text')}>{like}</span>
              </button>
              <button className={cx('interaction-btn')}>
                <FontAwesomeIcon className={cx('icon')} icon={faComment} />
                <span className={cx('text')}>{post.comment_count}</span>
              </button>
            </div>

            <div className={cx('post-info')}>
              {/* <div className={cx('author-info')}>
                <FontAwesomeIcon className={cx('icon')} icon={faUser} />
                <span className={cx('text')}>Quyen</span>
              </div> */}
              <div className={cx('date-info')}>
                <FontAwesomeIcon className={cx('icon')} icon={faCalendar} />
                <span className={cx('text')}>{post.date_create}</span>
              </div>
            </div>
          </div>
        </div>

        <div className={cx('commentList')} ref={listRef}>
          {comments.length > 0
            ? comments.map((comment, index) => (
                <div key={index} className={cx('comment')}>
                  <p className={cx('commentContent')}>{comment.content}</p>
                  <em className={cx('commentDate')}>{comment.date_create}</em>
                </div>
              ))
            : 'Hãy là người bình luận đầu tiên'}
          {/* <p onClick={() => setcountComment((prev) => prev + 1)}>Xem thêm</p> */}
        </div>
      </div>

      <form ref={formRef} className={cx('comment-action', { fixed: true })}>
        <input
          type="text"
          name="content"
          placeholder="Add a comment..."
          className={cx('input')}
          // onFocus={handleFocusInput}
          onKeyDown={handleKeyDown}
        />
        <button type="submit" onClick={onAddComment} className={cx('button')}>
          {windowWidth > 3 ? 'Comment' : <FontAwesomeIcon icon={faPaperPlane} />}
        </button>
      </form>
    </div>
  );
}

export default PostDetailMobile;
